import sal from "sal.js";

sal({
	once: true
});
